import { useCallback, useEffect, useState } from 'react';
import api from '../api';

/**
 * Monstre emblématique de chaque zone d'un serveur (images DofusDB).
 * Renvoie { monsters, setMonsters, reload } ; monsters = { [zone]: { monsterId, name, img, source } }.
 */
const useZoneMonsters = (serverId) => {
    const [monsters, setMonsters] = useState({});

    const reload = useCallback(() => {
        if (!serverId) return Promise.resolve();
        return api.get(`/zone-monsters/${serverId}`)
            .then(res => setMonsters(res.data?.monsters || {}))
            .catch(() => {}); // sans images, les pages restent utilisables
    }, [serverId]);

    useEffect(() => { reload(); }, [reload]);

    return { monsters, setMonsters, reload };
};

export default useZoneMonsters;
